import { createSlice } from '@reduxjs/toolkit'

import { REDUCERS } from 'common/store/reducerConstants'

export const rootSlice = createSlice({
  name: REDUCERS.ROOT,
  initialState: {},
  reducers: {},
})
